<template>
    <b-popover
        :target="target"
        triggers="click blur"
        placement="bottomleft"
        ref="popover"
        custom-class="datepicker-custom-range"
        @hidden="hidden"
        container="app"
    >
        <template v-slot:title>
            Custom Range
        </template>
        <div class="wrapper">
            <div class="start">
                <div class="selection">
                    <span class="label">
                        From : {{ dateStart || "Select date" }}
                    </span>
                </div>
                <div class="calendar">
                    <div class="overlay" v-show="dateStart !== null">
                        <!-- <span class="message">
                            Select end date.
                            <br />
                            To change start date, click Reset.
                        </span> -->
                    </div>
                    <date-picker
                        :key="dpStartKey"
                        :config="dpOptionsStart"
                        :value="null"
                        v-model="dateStart"
                        @dp-change="startChange"
                    />
                </div>
            </div>
            <div class="arrow-mid">
                →
            </div>
            <div class="end">
                <div class="selection">
                    <span class="label">
                        To : {{ dateEnd || "Select date" }}
                    </span>
                </div>
                <div class="calendar">
                    <div
                        class="overlay"
                        v-show="dateStart === null && dateEnd === null"
                    ></div>

                    <date-picker
                        :key="dpEndKey"
                        :config="dpOptionsEnd"
                        :value="null"
                        disabled
                        v-model="dateEnd"
                        @dp-change="endChange"
                    />
                </div>
            </div>
        </div>
        <div class="actions">
            <div>
                <b-button variant="secondary" @click="close">Close</b-button>
                <b-button variant="secondary" @click="reset" class="ml-2"
                    >Reset</b-button
                >
            </div>
            <b-button
                variant="primary"
                @click="apply"
                :disabled="disabledApplyButton"
            >
                Apply
            </b-button>
        </div>
    </b-popover>
</template>

<script>
export default {
    props: {
        target: {
            type: String
        }
    },
    data() {
        return {
            dpStartKey: 0, // for re-rendering purpose
            dpEndKey: 0, // for re-rendering purpose
            dateStart: null,
            dateEnd: null,
            dpOptionsStart: {
                format: "DD-MM-YYYY",
                inline: true,
                minDate: false,
                maxDate: false,
                useCurrent: false,
                timeZone: null
            },
            dpOptionsEnd: {
                format: "DD-MM-YYYY",
                inline: true,
                minDate: false,
                maxDate: false,
                useCurrent: false,
                timeZone: null
            },
            dateStartObj: null,
            dateEndObj: null
        };
    },
    computed: {
        disabledApplyButton() {
            if (this.dateStart && this.dateEnd) {
                return false;
            }
            return true;
        }
    },
    async mounted() {
        await this._getSetting();
        let format = this.getDateFormat();

        this.dpOptionsStart.format = format;
        this.dpOptionsStart.timeZone = this._timeZone;

        this.dpOptionsEnd.format = format;
        this.dpOptionsEnd.timeZone = this._timeZone;
    },
    methods: {
        open() {
            this.$refs.popover.$emit("open");
        },
        apply() {
            this.$emit("apply", this.dateStartObj, this.dateEndObj);
            this.close();
        },
        hideHandler(e) {
            e.preventDefault();
        },
        reset() {
            this.dateStart = null;
            this.dateEnd = null;
            this.dpOptionsEnd.minDate = false;
            this.dpOptionsStart.maxDate = false;
        },
        hidden() {
            this.reset();
        },
        startChange(e) {
            this.dpOptionsEnd.minDate = e.date;
            this.dateStartObj = e.date ? e.date.toDate() : null;

            if (!this.dateEnd && e.date) {
                this.dateEnd = e.date.format(this.getDateFormat());
            } else {
                this.dpEndKey++; // force re-render
            }
        },
        endChange(e) {
            this.dpOptionsStart.maxDate = e.date;
            this.dateEndObj = e.date ? e.date.toDate() : null;

            if (!this.dateStart && e.date) {
                this.dateStart = e.date.format(this.getDateFormat());
            } else {
                this.dpStartKey++; // force re-render
            }
        },
        close() {
            this.$refs.popover.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
.b-popover.datepicker-custom-range {
    max-width: 600px;
    width: 600px;

    .wrapper {
        display: grid;
        grid-template-columns: 1fr 30px 1fr;
        column-gap: 10px;
        padding: 10px;
    }

    .arrow-mid {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .actions {
        display: flex;
        justify-content: space-between;
    }

    .selection {
        margin-bottom: 5px;

        .label {
            font-weight: bold;
        }
    }

    input {
        background-color: white;
    }

    .calendar {
        position: relative;

        .overlay {
            position: absolute;
            display: flex;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.8);
            z-index: 99;
            // opacity: 0.7;
            cursor: not-allowed;
            align-items: center;
            justify-content: center;

            .message {
                display: none;
            }

            &:hover {
                .message {
                    display: flex;
                }
            }
        }
    }
}
</style>
